import core from './commuCore'
const output = {}

function deleteSlide (slide) {
  return core.ajax(slide, '/slide', 'delete')
}
output.deleteSlide = deleteSlide

function getSlide (data) {
  return core.ajax(data, '/slide', 'get')
}
output.getSlide = getSlide

function saveDragSlide (data) {
  return core.ajax(data, '/slide/drag', 'put')
}
output.saveDragSlide = saveDragSlide

function uploadSlide (data) {
  return core.ajax(data, '/slide/saveUpload', 'post')
}
output.uploadSlide = uploadSlide

export default output
